// ============================================================================
// KELO DIAMONDS — CONFIGURACIÓN DE PRODUCTOS (FUENTE ÚNICA DE PRECIOS)
// Cambia un precio aquí y se actualiza en toda la web (tarjetas, detalle,
// selector de tamaño, carrito, barra móvil, mensaje de WhatsApp y totales).
// NO cambiar los precios aprobados.
// ============================================================================

export const currency = { code: "USD", symbol: "$" };

// Tamaños del producto estrella (precio depende del CTW seleccionado)
export const sizes = [
  { id: "1ctw", label: "1 CTW", price: 149, perEarring: "~0.5 CT", mm: null },
  { id: "2ctw", label: "2 CTW", price: 189, perEarring: "~1 CT", mm: null },
  { id: "3ctw", label: "3 CTW", price: 229, perEarring: "~1.5 CT", mm: null },
  { id: "4ctw", label: "4 CTW", price: 279, perEarring: "~2 CT", mm: null },
];

export const defaultSizeId = "2ctw";

export const getSize = (id) => sizes.find((s) => s.id === id) || sizes[1];

// Imágenes (reemplazables). Fondo neutro para inspección; oscuras solo cinemáticas.
const IMG = {
  // Producto estrella — 3 fotografías profesionales reales (fondo blanco cálido)
  classic: "https://customer-assets-jai6qajn.emergentagent.net/job_diamond-lab-preview/artifacts/58c34rgw_E08C630D-7304-4907-B9D2-0CE2FF492559.png",
  classicAlt: "https://customer-assets-jai6qajn.emergentagent.net/job_diamond-lab-preview/artifacts/i0a19dua_IMG_6881.png",
  classicMacro: "https://customer-assets-jai6qajn.emergentagent.net/job_diamond-lab-preview/artifacts/u27l99yo_IMG_6880.png",
  halo: "https://customer-assets-jai6qajn.emergentagent.net/job_diamond-lab-preview/artifacts/99ewo1cr_E5DC17BC-80ED-451C-A7E2-C2ADD1BB9C40.png",
  princess: "https://images.unsplash.com/photo-1724937721228-f7bf3df2a4d8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  box: "https://images.unsplash.com/photo-1635767798638-3e25273a8236?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

// Catálogo. El precio del producto estrella se define por CTW (sizes).
export const products = [
  {
    id: "classic-studs",
    key: "classic",
    basePrice: 189, // = 2 CTW
    pricedBySize: true,
    images: [IMG.classic, IMG.classicAlt, IMG.classicMacro],
    thumb: IMG.classic,
    video: "/videos/macro-secondary.mp4",
    videoPoster: IMG.classic,
  },
  {
    id: "halo-studs",
    key: "halo",
    basePrice: 219,
    pricedBySize: false,
    images: [IMG.halo, IMG.classicAlt],
    thumb: IMG.halo,
    video: "/videos/macro-secondary.mp4",
    videoPoster: IMG.halo,
  },
  {
    id: "princess-studs",
    key: "princess",
    basePrice: 229,
    pricedBySize: false,
    images: [IMG.princess, IMG.classicAlt],
    thumb: IMG.princess,
    video: "/videos/macro-secondary.mp4",
    videoPoster: IMG.princess,
  },
];

export const flagshipId = "classic-studs";
export const getProduct = (id) => products.find((p) => p.id === id);

export const media = {
  heroVideo: "/videos/moissanite-hero.mp4",
  heroPoster: "/videos/moissanite-hero-poster.jpg",
  macroVideo: "/videos/macro-secondary.mp4",
  macroPoster: "/videos/moissanite-hero-poster.jpg",
  packaging: IMG.box,
};

export const formatPrice = (n) => `${currency.symbol}${n}`;
